export default "__VITE_ASSET__BgRSdq6T__"